import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./lesson.module.css"

@tagName("")
export default class ChooseFromGalleryLesson extends Component {
  readonly styles = styles
}
